import React, { Component } from "react";
import { Table, Icon } from "semantic-ui-react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import Moment from "moment";
import MlsServiceLog from "../../../models/MlsService/MlsServiceLog";
import MlsServiceLogType from "../../../constants/MlsService/MlsServiceLogType";

@observer
class MlsServiceLogTable extends Component {
  render() {
    const { mlsServiceLogs } = this.props;

    return (
      <Table celled padded>
        <Table.Body>
          {mlsServiceLogs.length === 0 ? (
            <Table.Row>
              <Table.Cell textAlign="center">
                <Icon name="search" />
                <span>No Results</span>
              </Table.Cell>
            </Table.Row>
          ) : null}
          {mlsServiceLogs.map(mlsServiceLog => (
            <Table.Row key={mlsServiceLog.mlsServiceLogId}>
              <Table.Cell textAlign="center">
                Your tour was {mlsServiceLog.typeId === MlsServiceLogType.CREATE ? "created" : "updated"} by an external
                source at
                {Moment(mlsServiceLog.creationDts).format(" MM/DD/YYYY HH:mm")}
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    );
  }
}

MlsServiceLogTable.propTypes = {
  mlsServiceLogs: PropTypes.arrayOf(PropTypes.instanceOf(MlsServiceLog)),
};

export default MlsServiceLogTable;
